import { config } from '@skytech/config'

import { openTab } from '@/util/misc'

export const goToForm = (code: string) => {
  openTab(`${config.FORM_URL}/${code}`)
}
